module.exports = __webpack_public_path__ + "img/google.6f4c74c3.svg";